<template>
  <div style="margin-top: 60px;">
    <!--<van-icon name="@/assets/login.png" />-->
    <van-icon name="/static/login.png" size="3rem" />
    <van-form validate-first @submit="showSuccess">
      <van-field v-model="memberNumber" name="cecID" label="员工号"
        :rules="cecIDRules" placeholder="Badge上的数字ID" />
      <van-field v-model="memberPassword" name="vcode" label="验证码"
        :rules="vcodeRules" placeholder="可在工会主页上查询" />
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">绑定</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import axios from 'axios';
import {Icon, Form, Toast, Dialog} from 'vant';
function beforeClose(action, done) {
  WeixinJSBridge.call('closeWindow');
}
export default {
  name: 'Binding',
  data () {
    this.cecIDRules = [
      {
        required: true,
        message: '员工号必填'
      },
      {
        validator: this.cecIDValidator,
        message: '员工号格式异常'
      }
    ];
    this.vcodeRules = [
      {
        required: true,
        message: '验证码必填'
      },
      {
        validator: this.vcodeValidator,
        message: '验证码格式异常'
      }
    ];
    return {
      memberNumber: '',
      memberPassword: ''
    }
  },
  mounted() {
    setTimeout(this.checkAlreadyBinded, 500);
  },
  methods: {
    checkAlreadyBinded() {
      // Check if it's already binded
      var uOpenid = sessionStorage.getItem('openid');
      axios.get('/api/binding', {
        params: {
          'openid': uOpenid
        }
      }).then((res) => {
        if (res.data == true) {
          Dialog({
            message: '已绑定账号无法再次绑定!',
            beforeClose
          });
        }
      }).catch((error) => {
        Toast.fail('无法连接服务器!');
      });
    },
    cecIDValidator(val) {
      return /\d{4,8}/.test(val);
    },
    vcodeValidator(val) {
      return /[0-9a-f]{8}/.test(val);
    },
    showSuccess() {
      var uOpenid = sessionStorage.getItem('openid');
      //console.log("openid=" + uOpenid);
      if (uOpenid == null) {
        Toast.fail('必须在微信中绑定账号!');
        return;
      }
      axios.post('/api/binding', {
        cecnb: this.memberNumber,
        vcode: this.memberPassword,
        openid: uOpenid
      })
      .then(function (response) {
        console.log(response);
        Dialog({
          message: '绑定成功!',
          beforeClose
        });
      })
      .catch(function (error) {
        console.log(error);
        Toast.fail('绑定失败');
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Binding.vue